import { styled } from 'styled-components';

type NameProps = {
  'data-is-missing': boolean;
};

// Wrapper around the entire component
export const Wrapper = styled.section`
  align-items: center;
  background-color: var(--color-background-compose);
  display: flex;

  /**
   * A fix for the scrolling issue on right sidebar for checklist overflow
   * pushing the page up
   * Resolved by creating another layer with position relative
   */
  position: relative;
  width: 100%;
`;

export const TopicName = styled.h2<NameProps>`
  -webkit-box-orient: vertical;
  /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
  color: ${props =>
    props['data-is-missing']
      ? 'var(--color-red-lighter)'
      : 'var(--color-primary)'};
  display: -webkit-box;
  font-size: var(--font-baseline);
  font-weight: var(--font-weight-heading);
  -webkit-line-clamp: var(--preference-label-line-clamp);
  margin: 0 var(--spacing-small);
  overflow: hidden;
  text-overflow: ellipsis;
`;
